import {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import API from "../../../services/api";

import "./CustomOrderReview.css";


function CustomOrderReview() {


    const PLATFORM_FEE_PERCENTAGE = 5;
  const {
    orderId,
  } = useParams();

  const navigate =
    useNavigate();


  // =====================================================
  // STATE
  // =====================================================

  const [
    order,
    setOrder,
  ] = useState(null);

  const [
    loading,
    setLoading,
  ] = useState(true);

  const [
    error,
    setError,
  ] = useState("");

  const [
    saving,
    setSaving,
  ] = useState(false);

  const [
    items,
    setItems,
  ] = useState([]);


  const [
    charges,
    setCharges,
  ] = useState({

    packingCharge: 0,

    deliveryCharge: 0,

  

    gst: 0,

    discount: 0,

  });


  // =====================================================
  // LOAD ORDER
  // =====================================================

  const loadOrder =
    useCallback(
      async () => {

        if (!orderId) {

          setError(
            "Custom order ID is missing."
          );

          setLoading(false);

          return;

        }


        try {

          setLoading(true);

          setError("");


         const response =
  await API.get(
    `/custom-orders/provider/${orderId}`
  );

          if (
            !response.data?.success
          ) {

            throw new Error(
              response.data?.message ||
              "Failed to load custom order."
            );

          }


          const loadedOrder =
            response.data.order;


          setOrder(
            loadedOrder
          );


          // ---------------------------------------------
          // Prepare editable items
          // ---------------------------------------------

          setItems(

            (
              loadedOrder.items ||
              []
            ).map(
              item => ({

                itemId:
                  item._id,

                itemName:
                  item.itemName ||
                  item.foodName ||
                  "",

                quantity:
                  item.quantity || 1,

                unit:
                  item.unit ||
                  "item",

                price:
                  item.price || "",

                itemStatus:
                  item.itemStatus ||
                  "Requested",

                providerNote:
                  item.providerNote ||
                  "",

              })
            )

          );


          // ---------------------------------------------
          // Existing charges
          // ---------------------------------------------

          setCharges({

            packingCharge:
              loadedOrder.packingCharge ||
              0,

            deliveryCharge:
              loadedOrder.deliveryCharge ||
              0,

            

            gst:
              loadedOrder.gst ||
              0,

            discount:
              loadedOrder.discount ||
              0,

          });


        } catch (error) {

          console.error(
            "Load Custom Order Error:",
            error
          );


          setError(

            error.response?.data?.message ||
            error.message ||
            "Failed to load custom order."

          );

        } finally {

          setLoading(false);

        }

      },
      [orderId]
    );


  useEffect(() => {

    loadOrder();

  }, [
    loadOrder,
  ]);


  // =====================================================
  // ITEM CHANGE
  // =====================================================

  const updateItem =
    (
      index,
      field,
      value
    ) => {

      setItems(
        previous =>
          previous.map(
            (item, itemIndex) => {

              if (
                itemIndex !== index
              ) {

                return item;

              }


              return {

                ...item,

                [field]:
                  value,

              };

            }
          )
      );

    };


  // =====================================================
  // CHARGE CHANGE
  // =====================================================

  const updateCharge =
    (
      field,
      value
    ) => {

      setCharges(
        previous => ({

          ...previous,

          [field]:
            value,

        })
      );

    };
// =====================================================
// PROVIDER TYPE
// =====================================================

const isCatering =
  order?.providerType === "Catering" ||
  !!order?.cateringDetails;
  // =====================================================
  // CALCULATE PREVIEW
  // =====================================================

  const subtotal =
  items.reduce(
    (
      total,
      item
    ) => {

      if (
        item.itemStatus ===
        "Unavailable"
      ) {

        return total;

      }

      const price =
        Number(item.price) || 0;

      const quantity =
        isCatering
          ? 1
          : Number(item.quantity) || 0;

      return (
        total +
        price * quantity
      );

    },
    0
  );


  const gst =
    Number(
      charges.gst
    ) || 0;


  const packingCharge =
    Number(
      charges.packingCharge
    ) || 0;


  const deliveryCharge =
    Number(
      charges.deliveryCharge
    ) || 0;


  const platformFee =
  Number(
    (
      subtotal *
      PLATFORM_FEE_PERCENTAGE /
      100
    ).toFixed(2)
  );

  const discount =
    Number(
      charges.discount
    ) || 0;


  const grandTotal =
    Math.max(
      0,
      subtotal +
      gst +
      packingCharge +
      deliveryCharge +
      platformFee -
      discount
    );


  // =====================================================
  // PRICE ORDER
  // =====================================================
// =====================================================
// PRICE ORDER
// =====================================================

const handlePriceOrder =
  async () => {

    if (!order) {
      return;
    }

    try {

      setSaving(true);
      setError("");

      // =================================================
      // BUILD FINAL PRICING PAYLOAD
      // =================================================

      const pricingPayload = {

        items:
          items.map(
            item => ({

              itemId:
                item.itemId,

              price:
                Number(
                  item.price
                ) || 0,

              itemStatus:
                item.itemStatus,

              providerNote:
                item.providerNote ||
                "",

            })
          ),

        packingCharge:
          Number(
            charges.packingCharge
          ) || 0,

        deliveryCharge:
          Number(
            charges.deliveryCharge
          ) || 0,

        // IMPORTANT:
        // Platform fee is calculated from
        // the provider-side subtotal.
        platformFee:
          Number(
            platformFee
          ) || 0,

        gst:
          Number(
            charges.gst
          ) || 0,

        discount:
          Number(
            charges.discount
          ) || 0,

      };


      console.log(
        "========================================"
      );

      console.log(
        "📤 SENDING CUSTOM ORDER PRICE"
      );

      console.log(
        "Catering:",
        isCatering
      );

      console.log(
        "Guests:",
        order.cateringDetails?.guests
      );

      console.log(
        "Items:",
        pricingPayload.items
      );

      console.log(
        "Subtotal:",
        subtotal
      );

      console.log(
        "Platform Fee:",
        platformFee
      );

      console.log(
        "GST:",
        gst
      );

      console.log(
        "Packing:",
        packingCharge
      );

      console.log(
        "Delivery:",
        deliveryCharge
      );

      console.log(
        "Discount:",
        discount
      );

      console.log(
        "Grand Total:",
        grandTotal
      );

      console.log(
        "Payload:",
        pricingPayload
      );

      console.log(
        "========================================"
      );


      // =================================================
      // SEND TO BACKEND
      // =================================================

      const response =
        await API.put(

          `/custom-orders/provider/${order._id}/price`,

          pricingPayload

        );


      if (
        !response.data?.success
      ) {

        throw new Error(

          response.data?.message ||

          "Failed to update pricing."

        );

      }


      // =================================================
      // UPDATE ORDER
      // =================================================

      setOrder(
        response.data.order
      );


      alert(
        "Custom order pricing added successfully."
      );


    } catch (error) {

      console.error(
        "Price Custom Order Error:",
        error
      );


      setError(

        error.response?.data?.message ||

        error.message ||

        "Failed to update pricing."

      );

    } finally {

      setSaving(false);

    }

  };


  // =====================================================
  // ACCEPT ORDER
  // =====================================================

  const handleAcceptOrder =
    async () => {

      if (!order) {

        return;

      }


      const confirmed =
        window.confirm(
          "Accept this custom order?"
        );


      if (!confirmed) {

        return;

      }


      try {

        setSaving(true);

        setError("");


       const response =
  await API.put(
    `/custom-orders/provider/${order._id}/accept`
  );


        if (
          !response.data?.success
        ) {

          throw new Error(
            response.data?.message ||
            "Failed to accept order."
          );

        }


        setOrder(
          response.data.order
        );


        alert(
          "Custom order accepted."
        );


      } catch (error) {

        console.error(
          "Accept Custom Order Error:",
          error
        );


        setError(

          error.response?.data?.message ||
          error.message ||
          "Failed to accept custom order."

        );

      } finally {

        setSaving(false);

      }

    };


  // =====================================================
  // REJECT ORDER
  // =====================================================

  const handleRejectOrder =
    async () => {

      if (!order) {

        return;

      }


      const reason =
        window.prompt(
          "Why are you rejecting this custom order?"
        );


      if (
        reason === null
      ) {

        return;

      }


      try {

        setSaving(true);

        setError("");


        const response =
  await API.put(
    `/custom-orders/provider/${order._id}/reject`,
            {

              reason:
                reason.trim(),

            }
          );


        if (
          !response.data?.success
        ) {

          throw new Error(
            response.data?.message ||
            "Failed to reject order."
          );

        }


        setOrder(
          response.data.order
        );


        alert(
          "Custom order rejected."
        );


      } catch (error) {

        console.error(
          "Reject Custom Order Error:",
          error
        );


        setError(

          error.response?.data?.message ||
          error.message ||
          "Failed to reject custom order."

        );

      } finally {

        setSaving(false);

      }

    };


  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (

      <div className="custom-order-review-page">

        <div className="custom-order-review-loading">

          Loading custom order...

        </div>

      </div>

    );

  }


  // =====================================================
  // ERROR
  // =====================================================

  if (
    error &&
    !order
  ) {

    return (

      <div className="custom-order-review-page">

        <div className="custom-order-review-error">

          <h2>
            Unable to load custom order
          </h2>

          <p>
            {error}
          </p>

          <button
            type="button"
            onClick={
              loadOrder
            }
          >
            Retry
          </button>

        </div>

      </div>

    );

  }


  if (!order) {

    return null;

  }


  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="custom-order-review-page">

      <div className="custom-order-review-container">


        {/* =================================================
            HEADER
        ================================================= */}

        <div className="custom-order-review-header">

          <span>
            HOMEFOODS BUSINESS
          </span>

          <h1>
            Custom Order Review
          </h1>

          <p>
            Review the customer's custom order
            and add your prices.
          </p>

        </div>


        {/* =================================================
            ERROR
        ================================================= */}

        {error && (

          <div className="custom-order-review-alert">

            {error}

          </div>

        )}


        {/* =================================================
            ORDER INFORMATION
        ================================================= */}
<div className="custom-order-review-card">

          <div className="custom-order-card-header">

            <div>

              <h2>
                Custom Order
              </h2>

              <p>
                Order ID
              </p>

              <strong>
                {order._id}
              </strong>

            </div>


            <div
              className={`custom-order-status status-${(
                order.customOrderStatus ||
                ""
              )
                .toLowerCase()
                .replaceAll(
                  " ",
                  "-"
                )}`}
            >

              {
                order.customOrderStatus
              }

            </div>

          </div>


          {/* =================================================
              CUSTOMER
          ================================================= */}

          <div className="custom-order-customer">

            <h3>
              Customer
            </h3>

            <p>
              <strong>
                {
                  order.customerSnapshot?.name ||
                  "Customer"
                }
              </strong>
            </p>

            {order.customerSnapshot?.phone && (

              <p>
                {
                  order.customerSnapshot.phone
                }
              </p>

            )}

            {order.customerSnapshot?.email && (

              <p>
                {
                  order.customerSnapshot.email
                }
              </p>

            )}

          </div>

{/* =================================================
    CATERING DETAILS
================================================= */}

{isCatering && (

  <div className="custom-order-catering-details">

    <div className="custom-order-catering-header">

      <div>

        <span>
          CATERING REQUEST
        </span>

        <h3>
          Function Details
        </h3>

      </div>

    </div>


    <div className="custom-order-catering-grid">

      {/* FUNCTION NAME */}

      <div className="custom-order-catering-field">

        <span>
          Function
        </span>

        <strong>
          {
            order.cateringDetails?.functionName ||
            "Not specified"
          }
        </strong>

      </div>


      {/* FUNCTION DATE */}

      <div className="custom-order-catering-field">

        <span>
          Function Date
        </span>

        <strong>

          {order.cateringDetails?.functionDate
            ? new Date(
                order.cateringDetails.functionDate
              ).toLocaleDateString(
                "en-IN",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }
              )
            : "Not specified"}

        </strong>

      </div>


      {/* GUESTS */}

      <div className="custom-order-catering-field">

        <span>
          Guests
        </span>

        <strong>

          {
            Number(
              order.cateringDetails?.guests
            ) || 0
          }

          {" "}
          Guests

        </strong>

      </div>

    </div>


    {/* DESCRIPTION */}

    {order.cateringDetails?.description && (

      <div className="custom-order-catering-description">

        <span>
          Catering Description
        </span>

        <p>
          {
            order.cateringDetails.description
          }
        </p>

      </div>

    )}

  </div>

)}
          {/* =================================================
              SPECIAL INSTRUCTIONS
          ================================================= */}

          {order.customOrderDetails?.specialInstructions && (

            <div className="custom-order-instructions">

              <h3>
                Special Instructions
              </h3>

              <p>
                {
                  order.customOrderDetails.specialInstructions
                }
              </p>

            </div>

          )}


          {/* =================================================
              ITEMS
          ================================================= */}

          <div className="custom-order-items-section">

           <h3>
  {isCatering
    ? "Requested Menu"
    : "Requested Items"}
</h3>

{isCatering && (

  <p className="custom-order-section-description">

    Price each menu item for the complete
    catering requirement.

  </p>

)}


            <div className="custom-order-items">

              {items.map(
                (
                  item,
                  index
                ) => (

                  <div
                    className="custom-order-item"
                    key={
                      item.itemId ||
                      index
                    }
                  >

                    <div className="custom-order-item-info">

  <h4>
    {item.itemName}
  </h4>

  {isCatering ? (

    <p>
      Menu item for{" "}
      <strong>
        {order.cateringDetails?.guests || 0}
      </strong>
      {" "}
      guests
    </p>

  ) : (

    <p>
      Quantity:{" "}
      {item.quantity}{" "}
      {item.unit}
    </p>

  )}

</div>


                    <div className="custom-order-item-controls">

                      <label>

                        Availability

                        <select
                          value={
                            item.itemStatus ===
                            "Unavailable"
                              ? "Unavailable"
                              : "Available"
                          }
                          onChange={
                            event =>
                              updateItem(
                                index,
                                "itemStatus",
                                event.target.value
                              )
                          }
                          disabled={
                            order.customOrderStatus ===
                              "Accepted" ||
                            order.customOrderStatus ===
                              "Rejected"
                          }
                        >

                          <option value="Available">
                            Available
                          </option>

                          <option value="Unavailable">
                            Unavailable
                          </option>

                        </select>

                      </label>


                    <label>

  {isCatering
    ? "Menu Price"
    : "Price"}

  <div className="price-input">

    <span>
      ₹
    </span>

    <input
      type="number"
      min="0"
      step="0.01"
      value={
        item.price
      }
      onChange={
        event =>
          updateItem(
            index,
            "price",
            event.target.value
          )
      }
      disabled={
        item.itemStatus ===
        "Unavailable"
      }
    />

  </div>

</label>


                     <label>

  Provider Note

  <input
    type="text"
    value={
      item.providerNote
    }
    onChange={
      event =>
        updateItem(
          index,
          "providerNote",
          event.target.value
        )
    }
    placeholder="Optional note"
    disabled={
      saving ||
      order.customOrderStatus === "Accepted" ||
      order.customOrderStatus === "Rejected"
    }
  />

</label>

                    </div>

                  </div>

                )
              )}

            </div>

          </div>


          {/* =================================================
              CHARGES
          ================================================= */}

          {/* =================================================
    CHARGES
================================================= */}

<div className="custom-order-charges">

  <h3>
    Additional Charges
  </h3>

  <div className="custom-order-charge-grid">

    {[
      [
        "packingCharge",
        "Packing Charge",
      ],
      [
        "deliveryCharge",
        "Delivery Charge",
      ],
      [
        "gst",
        "GST",
      ],
      [
        "discount",
        "Discount",
      ],
    ].map(
      ([field, label]) => (

        <label
          key={field}
        >

          {label}

          <div className="price-input">

            <span>
              ₹
            </span>

            <input
              type="number"
              min="0"
              step="0.01"
              value={
                charges[field]
              }
              onChange={
                event =>
                  updateCharge(
                    field,
                    event.target.value
                  )
              }
            />

          </div>

        </label>

      )
    )}

  </div>


  {/* =================================================
      AUTOMATIC PLATFORM FEE
  ================================================= */}

  <div className="custom-order-platform-fee-info">

    <div>

      <span>
        HomeFoods Platform Fee
      </span>

      <small>
        {PLATFORM_FEE_PERCENTAGE}% of subtotal
      </small>

    </div>

    <strong>
      ₹{platformFee.toFixed(2)}
    </strong>

  </div>

</div>

          {/* =================================================
              TOTAL
          ================================================= */}

          <div className="custom-order-summary">

            <div>

              <span>
                Subtotal
              </span>

              <strong>
                ₹{subtotal.toFixed(2)}
              </strong>

            </div>


            <div>

              <span>
                GST
              </span>

              <strong>
                ₹{gst.toFixed(2)}
              </strong>

            </div>


            <div>

              <span>
                Packing
              </span>

              <strong>
                ₹{packingCharge.toFixed(2)}
              </strong>

            </div>


            <div>

              <span>
                Delivery
              </span>

              <strong>
                ₹{deliveryCharge.toFixed(2)}
              </strong>

            </div>


            <div>

              <span>
                Platform Fee
              </span>

              <strong>
                ₹{platformFee.toFixed(2)}
              </strong>

            </div>


            <div>

              <span>
                Discount
              </span>

              <strong>
                - ₹{discount.toFixed(2)}
              </strong>

            </div>


            <div className="custom-order-grand-total">

              <span>
                Grand Total
              </span>

              <strong>
                ₹{grandTotal.toFixed(2)}
              </strong>

            </div>

          </div>


          {/* =================================================
              ACTIONS
          ================================================= */}

          <div className="custom-order-actions">

            <button
              type="button"
              className="custom-order-reject"
              onClick={
                handleRejectOrder
              }
              disabled={
                saving ||
                order.customOrderStatus ===
                  "Accepted" ||
                order.customOrderStatus ===
                  "Rejected"
              }
            >

              Reject Order

            </button>


            <button
              type="button"
              className="custom-order-price"
              onClick={
                handlePriceOrder
              }
              disabled={
                saving ||
                order.customOrderStatus ===
                  "Accepted" ||
                order.customOrderStatus ===
                  "Rejected"
              }
            >

              {saving
                ? "Saving..."
                : "Send Price"}

            </button>


            {order.customOrderStatus ===
              "Price Added" && (

              <button
                type="button"
                className="custom-order-accept"
                onClick={
                  handleAcceptOrder
                }
                disabled={
                  saving
                }
              >

                Accept Order

              </button>

            )}

          </div>


          {/* =================================================
              BACK
          ================================================= */}

          <button
            type="button"
            className="custom-order-back"
            onClick={() =>
              navigate(
                "/business/messages"
              )
            }
          >

            ← Back to Messages

          </button>

        </div>

      </div>

    </div>

  );

}


export default CustomOrderReview;